/** @format */
const comps = {}; // ./components下的组件

const modules = import.meta.glob('./*.vue', { eager: true });
for (const path in modules) {
	const cname = path.replace(/(\.\/|\.vue)/g, '');
	comps[cname] = (modules[path] as any).default;
}

const getWidgetName = (type: string) => {
	const component = comps[comAttr[type]?.com];
	if (component) {
		return component;
	} else {
		//throw new Error('没有该类型组件');
		return null;
	}
};

export { getWidgetName };

export default comps;

export const comAttr = {
	'/workbench/calendar': {
		com: 'calendar',
		x: 0,
		y: 0,
		w: 16,
		h: 160,
		minW: 8,
		minH: 160,
	},
	'/workbench/myService': {
		com: 'myService',
		x: 16,
		y: 0,
		w: 8,
		h: 140,
		minW: 7,
		minH: 100,
	},
	'/workbench/appSwitch': {
		com: 'appSwitch',
		x: 16,
		y: 6,
		w: 8,
		h: 100,
		minW: 7,
		minH: 86,
	},
	'/workbench/workOrder': {
		com: 'workOrder',
		x: 0,
		y: 13,
		w: 16,
		h: 130,
		minW: 8,
		minH: 110,
	},
	'/workbench/noticeList': {
		com: 'noticeList',
		x: 16,
		y: 13,
		w: 8,
		h: 130,
		minW: 4,
		minH: 91,
	},
	'/resourceOverview': {
		com: 'resourceOverview',
		x: 0,
		y: 173,
		w: 15,
		h: 117,
		minW: 10,
		minH: 80,
	},
	'/orderOverview': {
		com: 'orderOverview',
		x: 15,
		y: 145,
		w: 9,
		h: 145,
		minW: 8,
		minH: 100,
	},
	'/alarmOverview': {
		com: 'alarmOverview',
		x: 15,
		y: 0,
		w: 9,
		h: 145,
		minW: 7,
		minH: 120,
	},
	'/applicationSystem': {
		com: 'applicationSystem',
		x: 0,
		y: 0,
		w: 15,
		h: 173,
		minW: 10,
		minH: 120,
	},
	'/serviceCatalog': {
		com: 'serviceCatalog',
		x: 16,
		y: 0,
		w: 8,
		h: 60,
		minW: 4,
		minH: 53,
	},
	'/gongan': {
		com: 'gongan',
		x: 16,
		y: 0,
		w: 100,
		h: 200,
		minW: 4,
		minH: 53,
	},
	'/province': {
		com: 'province',
		x: 16,
		y: 0,
		w: 100,
		h: 200,
		minW: 4,
		minH: 53,
	},
	'/workbench/todoList': {
		com: 'todoList',
		x: 16,
		y: 13,
		w: 8,
		h: 130,
		minW: 4,
		minH: 91,
	},
	'/workbench/inspectionList': {
		com: 'inspectionList',
		x: 16,
		y: 13,
		w: 8,
		h: 130,
		minW: 4,
		minH: 91,
	},
	'/workbench/alertList': {
		com: 'alertList',
		x: 16,
		y: 13,
		w: 8,
		h: 130,
		minW: 4,
		minH: 91,
	},
	'/workbench/bookList': {
		com: 'bookList',
		x: 16,
		y: 13,
		w: 8,
		h: 130,
		minW: 4,
		minH: 91,
	},
};
